export enum LinkViewType {
  LoadLoad = "LoadLoad",
  ControllerLoad = "ControllerLoad",
}
